import { RootState } from '../store'
export const selectCoutSupplementaires = (state: RootState) =>
  state.coutSupplementaire.coutSupplementaires
export const selectLoading = (state: RootState) =>
  state.coutSupplementaire.loading
export const selectError = (state: RootState) => state.coutSupplementaire.error
